export default class MainMenu {
  constructor () {
    this.toggleElements = document.querySelectorAll("[data-trigger-main-menu]")
    this.closeElements = document.querySelectorAll("[data-trigger-close-menu]")
    this.menus = document.querySelectorAll("[data-is-main-menu]")
    this.classToggle = "show"

    this.bindEvents()
  }

  bindEvents () {
    this.toggleElements.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        toggle.classList.toggle(this.classToggle)
        this.menus.forEach((menu) => menu.classList.toggle(this.classToggle))
      })
    })

    this.closeElements.forEach((close) => {
      close.addEventListener("click", () => {
        this.toggleElements.forEach((toggle) => toggle.classList.remove(this.classToggle))
        this.menus.forEach((menu) => menu.classList.remove(this.classToggle))
      })
    })
  }
}
